import React from 'react'

function TextSmallButton({ name, showLeadingIcon, showTrailingIcon }) {
    return (
        <div className='flex flex-row space-x-8 justify-center items-center '>
            {showLeadingIcon && (
                <div className='text-white'>
                    {showLeadingIcon}
                </div>
            )}
            <div className='text-white text-14 font-bold font-roboto-condensed cursor-pointer'>
                {name}
            </div>
            {showTrailingIcon && (
                <div className='text-white'>
                    {showTrailingIcon}
                </div>
            )}
        </div>
    )
}

export default TextSmallButton;